import React, { useState } from 'react'
import loadable from '@loadable/component'
import { getAlgoliaSearchClient } from '@/helpers/getAlgoliaSearchClient'
import { getCurrentLang } from '@/helpers/getCurrentLang'
import { HelpSearchResultsSectionType } from './types'
import './HelpSearchResultSection.css'

const InstantSearch = loadable(() =>
  import('react-instantsearch-dom').then((module) => ({
    default: module.InstantSearch
  }))
)

const Configure = loadable(() =>
  import('react-instantsearch-dom').then((module) => ({
    default: module.Configure
  }))
)

const Index = loadable(() =>
  import('react-instantsearch-dom').then((module) => ({
    default: module.Index
  }))
)

const SearchResults = loadable(() => import('@/components/molecules/SearchResults/SearchResults'), {
  resolveComponent: (component) => component.SearchResults
})

const HelpHits = loadable(() => import('@/components/molecules/HelpHits/HelpHits'), {
  resolveComponent: (component) => component.HelpHits
})

const CustomPagination = loadable(() => import('@/components/molecules/Pagination/Pagination'), {
  resolveComponent: (component) => component.CustomPagination
})

const IndexContent = loadable(() => import('@/components/molecules/IndexContent/IndexContent'), {
  resolveComponent: (component) => component.IndexContent
})

const VirtualSearchBox = loadable(() => import('@/components/molecules/VirtualSearchBox/VirtualSearchBox'), {
  resolveComponent: (component) => component.VirtualSearchBox
})

export function HelpSearchResultsSection({ title, no_results, location }: HelpSearchResultsSectionType) {
  const [query, setQuery] = useState('')
  const searchClient = getAlgoliaSearchClient(false)
  const language = getCurrentLang(location)
  const index = process.env.GATSBY_ALGOLIA_INDEX_HELP || ''

  return (
    <InstantSearch searchClient={searchClient} indexName={index} onSearchStateChange={({ query: q }) => setQuery(q)}>
      <Configure attributesToSnippet={['description', 'content']} filters={`language:${language}`} hitsPerPage={4} />
      <section
        className="flex items-center flex-col max-w-screen-desktop mx-auto p-24 laptop:px-9 laptop:py-90 my-40"
        id="helpSearchSection"
      >
        <h1 className="text-headingL-mobile tablet:text-headingL font-bold text-accent-navy-blue text-center mb-20">
          {title}
        </h1>
        {query && (
          <h2 className="text-headingS-mobile tablet:text-headingM font-bold text-primary-500 text-center mb-48">
            {query}
          </h2>
        )}
        <VirtualSearchBox className="hidden" location={location} />
        <Index indexName={index} key="beebole_pages">
          <IndexContent>
            <SearchResults noResults={no_results}>
              <HelpHits query={query} />
            </SearchResults>
            <CustomPagination showFirst={false} />
          </IndexContent>
        </Index>
      </section>
    </InstantSearch>
  )
}

export default HelpSearchResultsSection
